import { colors } from "@mui/material";
import StatusChip from "./StatusChip";
import { useTranslation } from "react-i18next";
import { CreditorStatus } from "Domain/User/Entity/CreditorData";

type CreditorStatusProps = {
  status: CreditorStatus;
};

const key = 700;
const statusColors: Record<CreditorStatus, string> = {
  CREATED: colors.orange[key],
  COMPLETED: colors.deepOrange[key],
  SIGNED: colors.blue[key],
  VALIDATED: colors.green[key],
};

export default function CreditorStatusChip({ status }: CreditorStatusProps) {
  const { t } = useTranslation();
  const statusColor = status in statusColors ? statusColors[status] : "white";

  return (
    <StatusChip
      color={statusColor}
      label={t(`STATUS.LABEL.creditor.${status}`)}
      info={t(`STATUS.INFO.creditor.${status}`)}
    />
  );
}
